let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kKbG0")).then(() => parcelRequire('7p86r'));